import classnames from "classnames";
import {IconContext} from "react-icons";
import {FaInfo, FaPlus} from "react-icons/fa6";
import {GoDotFill} from "react-icons/go";
import {Link, useLocation} from "react-router";

import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {QUERY} from "@/pages/checks/constants.ts";

import styles from "./CheckItem.module.css";

interface CheckItemProps {
  name: string;
  type: MonitoringServiceType;
  helpText: string;
  usage: number;
  supportURL: string;
}

export const CheckItem = ({name, helpText, usage, type, supportURL}: CheckItemProps) => {
  const location = useLocation();

  return (
    <div className={classnames("d-flex align-items-center", styles.checkItem)}>
      <IconContext.Provider value={{size: "0.75rem"}}>
        <Link
          to={`/checks/create?${QUERY.MONITORING_SERVICE_TYPE}=${type}`}
          className={classnames(styles.action, "d-flex align-items-center")}
          state={{from: location}}
        >
          <FaPlus className="me-1" />
          <small className="">{name}</small>
        </Link>
        <GoDotFill className="text-secondary me-1" />
        <span className="me-1">{usage}</span>
        {helpText && (
          <span className={classnames("d-flex align-items-center", styles.help)}>
            <GoDotFill className="text-secondary me-1" />
            <a
              className={classnames(styles.info, "d-flex align-items-center")}
              href={supportURL}
              target="_blank"
              rel="noreferrer"
              bs-data-toogle="tooltip"
              title={helpText}
            >
              <FaInfo />
            </a>
          </span>
        )}
      </IconContext.Provider>
    </div>
  );
};
